import { IconProps } from './IconProps';
export function IllustrationControlBackgroundCircles(props: IconProps) {
    return (
        <svg
            {...props}
            width="700"
            height="700"
            viewBox="0 0 700 700"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M350 700C543.3 700 700 543.3 700 350C700 156.7 543.3 0 350 0C156.7 0 0 156.7 0 350C0 543.3 156.7 700 350 700Z"
                fill="#0047FF"
                fillOpacity="0.05"
            />
            <path
                d="M350 700C474.816 700 576 598.816 576 474C576 349.184 474.816 248 350 248C225.184 248 124 349.184 124 474C124 598.816 225.184 700 350 700Z"
                fill="#E5EDFF"
            />
        </svg>
    );
}
